<template>
  <b-tabs>

    <b-tab>
      <template slot="title">
            <i class='icon-list'></i>
        </template>
      <AsideEventComponent :obj="eventList" />
    </b-tab>

    <b-tab @click="onTabMessageClicked()">
      <template slot="title">
            <i class='icon-speech'></i>
        </template>
      <AsideMessageComponent :obj="messageList" />
    </b-tab>

    <b-tab>
      <template slot="title">
            <i class='icon-settings'></i>
        </template>
      <AsideConfigComponent />
    </b-tab>

  </b-tabs>
</template>

<script>
import axios from "axios";
import { Switch as cSwitch } from '@coreui/vue'
import AsideEventComponent from '@/containers/AsideEventComponent';
import AsideMessageComponent from '@/containers/AsideMessageComponent';
import AsideConfigComponent from '@/containers/AsideConfigComponent';

export default {
  name: 'DefaultAside',
  components: {
    cSwitch,
    AsideMessageComponent,
    AsideConfigComponent,
    AsideEventComponent
  },
  data () {
    return {
      eventList: [],
      messageList: []
    }
  },
  methods: {
    async getMessagesAside() {      
        var s = this
        var currentUser = s.$store.state.currentUser;

        //console.log("Recuperando...")

        if(currentUser && currentUser.id > 0) {
          var url = s.$store.state.ws_url + "/message/user?typeId=1&uid=" + currentUser.id + "&sid=" + currentUser.sid
          //console.log(url)
          await axios.get(
              url
          ).then(function(resp) {
            s.messageList = resp.data.obj
          })
          .catch(function(error) {
              console.log(error);
          }); 
        }

    },

    onTabMessageClicked() {
      //console.log("Guia Mensagem clicada")
      this.getMessagesAside()
    }
  }
}
</script>
